// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_GetDevicesByFranquiasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/get_devices_by_franquias
 *
 * Returns the list of messaging devices (WhatsApp + Instagram) attached to
 * the requested franchises. Each element is a synthetic inbox-device shape
 * enriched with label, api_url, instance_token, instance_name, franquia_ids,
 * and (for Instagram) a typed capabilities object.
 */
import type { DevicesFranquias_InboxDeviceRow } from './DevicesFranquias_InboxDeviceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DevicesFranquias_GetDevicesByFranquiasResponseDados = DevicesFranquias_InboxDeviceRow[];

export type DevicesFranquias_GetDevicesByFranquiasResponse = ApiResponse<DevicesFranquias_GetDevicesByFranquiasResponseDados>;

registerResponseContract('DevicesFranquias_GetDevicesByFranquiasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      device_id:      { type: 'number',  required: true },
      provider_type:  { type: 'string',  required: false },
      label:          { type: 'string',  required: false },
      api_url:        { type: 'string',  required: false },
      instance_token: { type: 'string',  required: false },
      instance_name:  { type: 'string',  required: false },
      franquia_ids:   { type: 'array',   required: false },
      capabilities: {
        type: 'object',
        required: false,
        fields: {
          templates:          { type: 'boolean', required: false },
          messagingWindow24h: { type: 'boolean', required: false },
          pushToTalk:         { type: 'boolean', required: false },
          interactiveButtons: { type: 'boolean', required: false },
          deleteForEveryone:  { type: 'boolean', required: false },
          conversationInitiation: {
            type: 'object',
            required: true,
            fields: {
              canInitiate: { type: 'boolean', required: false },
            },
          },
        },
      },
    },
  },
})
